// extracted by mini-css-extract-plugin
var _1 = "form-navigation-buttons__wVONE";
var _2 = "summary-back-button__Qh2tn";
export { _1 as "form-navigation-buttons", _2 as "summary-back-button" }
